import UIButton from 'UIComponents/button/UIButton';
import { H4, H6 } from 'UIComponents/elements/headings';
import UIIllustration from 'UIComponents/image/UIIllustration';
import UITileSection from 'UIComponents/tile/UITileSection';
import UITile from 'UIComponents/tile/UITile';
import ApprovalRequestAccessModal from '../requestAccessModal/ApprovalRequestAccessModal';
import { useState } from 'react';
import ApprovalNotEnabledStep from './ApprovalNotEnabledStep';
import { trackInteraction } from '../../utils/usageTracker';
import * as trackingConstants from '../../constants/trackingConstants';
import { useApprovalContext } from '../../hooks/useApprovalContext';
import { ApprovalRequestAccessHeadingI18n, ApprovalRequestAccessDescriptionI18n, ApprovalRequestAccessStepTwoI18n, ApprovalRequestAccessStepThreeI18n } from '../i18n/ApprovalRequestAccessI18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import useApprovalConditions from '../../hooks/useApprovalConditions';
import PortalIdParser from 'PortalIdParser';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function ApprovalNotEnabled() {
  const [showRequestAccessModal, setShowRequestAccessModal] = useState(false);
  const {
    meta
  } = useApprovalContext();
  const {
    isSuperAdmin
  } = useApprovalConditions();
  const portalId = PortalIdParser.get();
  const closeRequestAccessModal = () => {
    setShowRequestAccessModal(false);
  };
  const openRequestAccessModal = () => {
    setShowRequestAccessModal(true);
    trackInteraction(trackingConstants.APPROVAL_REQUEST_ACCESS_MODAL_OPENED, meta.approvalType);
  };
  const handleAdminGoToSettingsTracking = () => {
    trackInteraction(trackingConstants.APPROVAL_REQUEST_ACCESS_ADMIN_GO_TO_SETTINGS_BUTTON, meta.approvalType);
  };
  return /*#__PURE__*/_jsxs("div", {
    className: "flex-column align-center p-all-5 m-left-3 m-right-3",
    "data-test-id": "product-approvals-approval-sidebar-not-enabled",
    children: [/*#__PURE__*/_jsx("div", {
      className: "justify-center m-bottom-9",
      children: /*#__PURE__*/_jsx(UIIllustration, {
        name: "approvals",
        width: 150
      })
    }), /*#__PURE__*/_jsxs("div", {
      className: "flex-column m-bottom-3 text-center",
      children: [/*#__PURE__*/_jsx(H4, {
        children: /*#__PURE__*/_jsx(ApprovalRequestAccessHeadingI18n, {
          approvalType: meta.approvalType
        })
      }), /*#__PURE__*/_jsx("p", {
        children: /*#__PURE__*/_jsx(ApprovalRequestAccessDescriptionI18n, {
          approvalType: meta.approvalType
        })
      })]
    }), /*#__PURE__*/_jsx(UITile, {
      compact: true,
      children: /*#__PURE__*/_jsxs(UITileSection, {
        children: [/*#__PURE__*/_jsx(H6, {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "productApprovals.ApprovalRequestAccess.steps.heading"
          })
        }), /*#__PURE__*/_jsxs("div", {
          className: "m-bottom-3",
          children: [/*#__PURE__*/_jsx(ApprovalNotEnabledStep, {
            iconName: "send",
            text: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "productApprovals.ApprovalRequestAccess.steps.stepOne"
            })
          }), /*#__PURE__*/_jsx(ApprovalNotEnabledStep, {
            iconName: "approvals",
            text: /*#__PURE__*/_jsx(ApprovalRequestAccessStepTwoI18n, {
              approvalType: meta.approvalType
            })
          }), /*#__PURE__*/_jsx(ApprovalNotEnabledStep, {
            iconName: "publish",
            text: /*#__PURE__*/_jsx(ApprovalRequestAccessStepThreeI18n, {
              approvalType: meta.approvalType
            })
          })]
        })]
      })
    }), isSuperAdmin ? /*#__PURE__*/_jsx(UIButton, {
      className: "m-top-5",
      "data-test-id": "product-approvals-sidebar-button-go-to-settings",
      use: "tertiary",
      href: `/settings/${portalId}/approvals`,
      onClick: handleAdminGoToSettingsTracking,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "productApprovals.ApprovalRequestAccess.requestAccessButtonAdmin"
      })
    }) : /*#__PURE__*/_jsx(UIButton, {
      className: "m-top-5",
      "data-test-id": "product-approvals-sidebar-button-request-access",
      use: "tertiary",
      onClick: openRequestAccessModal,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "productApprovals.ApprovalRequestAccess.requestAccessButtonRequester"
      })
    }), showRequestAccessModal && /*#__PURE__*/_jsx(ApprovalRequestAccessModal, {
      closeRequestAccessModal: closeRequestAccessModal
    })]
  });
}
export default ApprovalNotEnabled;